import { post } from "./Api";

export function VerifyToken({ data }) {
  return post({ url: `/verifyToken`, data });
}
